import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { deleteQuizTemplateRequested } from 'features/quizzes/actions';

export function* deleteQuizTemplateSaga(action: ReturnType<typeof deleteQuizTemplateRequested>) {
  yield call(SignalingSocket.send, { event: 'deleteQuizTemplate', data: action.payload });
}
